import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router/dom';
import { queryClient } from './lib/query-client';
import { quizRouter } from './quiz-router';
import { ConfirmationProvider } from './components/ConfirmationProvider';
import './style.css';
import './features/quizzes/quiz.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ConfirmationProvider>
        <RouterProvider router={quizRouter} />
      </ConfirmationProvider>
    </QueryClientProvider>
  </StrictMode>,
);
